import {
  type NavigateOptions,
  type RouteObject,
  useNavigate,
  useParams,
} from 'react-router';
import { stripPdbFromUrl } from '../modules/utils/storeUtils';

export enum PATHS {
  compare = `compare`,
  msc = ':mscId',
  orderNumber = 'order/:orderNumberId',
  terms = 'terms',
  expired = 'expired',
  welcome = '',
  all = '*',
}

export const transformPaths = (routes: RouteObject[]) =>
  routes.map((route) => ({
    ...route,
    path: route.path === PATHS.all ? PATHS.all : `/:pdbId/${route.path}`,
  }));

const useAppNavigate = () => {
  const routerNavigate = useNavigate();
  const params = useParams();
  const baseUrl = `/${params.pdbId}`;

  const isRoutePath = (path: PATHS | string): path is PATHS => path in PATHS;

  return (
    path: PATHS | string,
    options?: Omit<NavigateOptions, 'relative'>
  ) => {
    if (isRoutePath(path)) {
      routerNavigate(`${baseUrl}/${path}`, options);
    } else {
      routerNavigate(stripPdbFromUrl(path), options);
    }
  };
};

export default useAppNavigate;
